import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANGUAGES } from "../i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "defalco_lang";

function detectInitialLang() {
  if (typeof window === "undefined") return "de";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && LANGUAGES.includes(stored)) return stored;
  const browser = (navigator.language || "de").slice(0, 2).toLowerCase();
  if (LANGUAGES.includes(browser)) return browser;
  return "de";
}

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("de");

  useEffect(() => {
    setLang(detectInitialLang());
  }, []);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    } catch (_) {}
  }, [lang]);

  const changeLang = useCallback((next) => {
    if (LANGUAGES.includes(next)) setLang(next);
  }, []);

  const t = translations[lang] || translations.de;

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
